/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Marker from 'fierry/flux/dependency/marker';


export default class
{
  constructor (entity)
  {
    this.entity = entity;

    this.marker = Marker.None;
  }


  install (dependences)
  {
    this.entity.install(dependences);
  }


  isExportable ()
  {
    return this.entity.isExportable();
  }


  getEntityDependences ()
  {
    const entityDependences = this.entity.getDependences();

    return this.visibility ? [...entityDependences, this.visibility] : entityDependences;
  }


  getEntity ()
  {
    return this.entity;
  }


  // - - - - - - - - - Visibility - - - - - - - - -


  setVisibility (visibility)
  {
    this.visibility = visibility;
  }


  getVisibility ()
  {
    return this.visibility;
  }


  // - - - - - - - - - Sort Marker - - - - - - - - -


  markEmpty ()
  {
    this.marker = Marker.None;
  }


  markTemporary ()
  {
    this.marker = Marker.Temporary;
  }


  markPermament ()
  {
    this.marker = Marker.Permanent;
  }


  isEmptyMarker ()
  {
    return this.marker === Marker.None;
  }


  isTemporaryMarker ()
  {
    return this.marker === Marker.Temporary;
  }


  isPermanentMarker ()
  {
    return this.marker === Marker.Permanent;
  }


}
